<div class="page-account__account-wrapper">
  @if ($isDesktop()) {
    <page-account-sidebar class="sticky top-0 self-stretch"></page-account-sidebar>
  }
  <div class="page-account__account-content overflow-y-auto">
    <router-outlet></router-outlet>
  </div>
</div>
